export const WithPatchExperimentRepository = ({
  patch, experimentId, scope, edmCampaign,
}) => {
  const {
    values: {
      cid, aid,
    },
  } = scope;

  const currentEntity = edmCampaign
    .Customers
    .$withKey(cid)
    .Accounts
    .$withKey(aid);

  return currentEntity.Experiments
    .update(experimentId, patch);
};
